// ProductCard.jsx
// Card moderno com animações e ações
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'    
import { useStateValue } from '../../Middleware/context/StateProvider';

export default function ProductCard({ 
  id,
  img,
  nameProduto,
  price,
  description,
  fornecedor,
   destinoVenda,
   tipo,
   taxa,
   idSupplier,
   whatsapp,
   category,
   tipoArtigo,
   size

}) {
  const navigate = useNavigate();
  const location=useLocation();
      const { dispatch } = useStateValue();
const parts=location.pathname.split('/')
const quantity=1;



const formatCurrency = (value)=>{

  return new Intl.NumberFormat("pt-PT").format(value)+ 'KZ';
}


  const addToCart = () => {
 const tipoItem = tipoArtigo==='Produtos';

 tipoItem?
    dispatch({
      type: 'ADD_TO_BASKET',
      item: {
        id,
        img,
        nameProduto,
        price,
        description,
        fornecedor,
       destinoVenda,
        tipo,
        taxa,
        idSupplier,
        quantidade: quantity,
        status:"Pending",
        data: new Date().toLocaleString(),
        size,
       
     
      }
    })
    :alert('Sem permissao para adicionar esse produto')
  
  }
 
const callWhatsapp=()=>{

    window.open(`https://wa.me/${whatsapp? whatsapp:'+244991660829'}`, "_blank");
 
}


  return (
    <article className="product-card">
      <div className="image-box" onClick={(e) => navigate(`/Details/${parts[2]}/${parts[3]}/${id}`)}>
        <img src={img} alt={id} />
      </div>

      <div className="card-info">
        <h3>{nameProduto}</h3>
        <p className="supplier">{fornecedor} - { category}</p>
        <strong className="price">
          <p value={price + taxa} displayType={'text'} thousandSeparator prefix="Kz " >{formatCurrency(price+taxa)} </p>
        </strong>
      </div>

      <div className="card-actions">
        <button onClick={(e)=>{addToCart()}} className="btn-buy">Adicionar no Carrinho</button>
        <button className="btn-whatsapp" onClick={callWhatsapp}>WhatsApp</button>
      </div>
    </article>
  )
}
